import React from "react";
import "./IncrementTextBox.css";

const IncrementTextbox = ({ value, onIncrement, onDecrement, onChange }) => {
  return (
    <div className="increment-textbox">
      <button type="button" onClick={onDecrement} className="decrement-btn">
        -
      </button>
      <input
        type="number"
        value={value}
        onChange={onChange}
        className="textbox-input"
        min="1"
      />
      <button type="button" onClick={onIncrement} className="increment-btn">
        +
      </button>
    </div>
  );
};

export default IncrementTextbox;
